import { isUndefinedOrEmpty } from '@afterpay/utils/string'
import DOMPurify from 'dompurify'
import { isNullOrUndefined } from '@afterpay/utils'
import { AppleGatewayCheckoutResponse } from '../../../state'

export const validateSessionIdentifier = (sessionIdentifier: string | null): string | null => {
  if (isUndefinedOrEmpty(sessionIdentifier) || sessionIdentifier === null) {
    return null
  }

  const sanitized = DOMPurify.sanitize(sessionIdentifier.trim(), { ALLOWED_TAGS: [], ALLOWED_ATTR: [] })

  return sanitized !== '' ? sanitized : null
}

export const validateVerifier = (verifier: string | null): string | null => {
  if (isUndefinedOrEmpty(verifier) || verifier === null) {
    return null
  }

  const sanitized = DOMPurify.sanitize(verifier.trim(), { ALLOWED_TAGS: [], ALLOWED_ATTR: [] })

  return sanitized !== '' ? sanitized : null
}

export const validateCreateApplePayCheckoutResponse = (response: AppleGatewayCheckoutResponse): boolean => {
  const { token, expires, redirectCheckoutUrl } = response

  if (isNullOrUndefined(token) || isUndefinedOrEmpty(expires) || isUndefinedOrEmpty(redirectCheckoutUrl)) {
    return false
  }

  const expiryDate = new Date(expires)
  if (isNaN(expiryDate.getTime())) {
    return false
  }
  if (expiryDate <= new Date()) {
    return false
  }

  return true
}
